import EmberObject from '@ember/object';

export default EmberObject.extend({

  maxRetries: 4,
  promiseToRetry: undefined,

  generate(promiseGeneratorFunction, maxRetries) {
    maxRetries = (typeof maxRetries !== 'undefined') ? maxRetries : this.get('maxRetries');

    return function recursiveRetry() {
      if (maxRetries-- > 0) {
        return promiseGeneratorFunction().catch(recursiveRetry);
      }  else {
        return promiseGeneratorFunction();
      }
    }();
  },

});
